import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
    this.element.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close(event);
      } else if (event.key === "Enter") {
        this.saveAndClose(event);
      }
    });
  }

  disconnect() {
    this.element.removeEventListener("keydown", this);
  }

  close() {
    this.element.remove();
  }

  save(event, close = false) {
    if (this.#wasSubmittedFromUnwantedElement(event)) return;

    const closeButton = this.element.querySelector("#save-and-close");
    const form = this.element.querySelector("form");

    if (close && closeButton) {
      event.preventDefault();
      closeButton.click();
      return;
    }

    if (form) {
      event.preventDefault();
      form.requestSubmit();
    }
  }

  saveAndClose(event) {
    this.save(event, true);
  }

  #wasSubmittedFromUnwantedElement(event) {
    return (
      event.target.tagName === "TEXTAREA" || event.target.closest("trix-editor")
    );
  }
}
